export default __webpack_public_path__ + "static/media/tausendsassa-logo.bb1ceea8.svg";